import { Notes } from '@modeso/types__aumico-lib-annualreport-be';

export interface INotesComponentsListDelegation {
    getChangeOfComponent(change: Notes, index: number, componentIndex: number): void;
}
